import { render, staticRenderFns } from "./AtaView.vue?vue&type=template&id=989e8d2e"
import script from "./AtaView.vue?vue&type=script&lang=js"
export * from "./AtaView.vue?vue&type=script&lang=js"
import style0 from "./AtaView.vue?vue&type=style&index=0&id=989e8d2e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports